import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import SocialProject from "../components/SocialProject";
import SocialProjectList from "../components/SocialProjectList";
import SustainabilityReports from "../components/SustainabilityReports";
import SustainReport from "../components/SustainReport";
import NavArrow from "../components/NavArrow";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Slider from "react-slick";
import "./../styles/Sustainability.scss";
import "./../styles/Activities.scss";
import Api from "../common/api";

const Sustainability = () => {
  
  const [tabName, setTabName] = useState([
    {
      id: 1,
      name: "Politikalarımızxx",
      link: "/",
      content: "sanko ",
      submenu: [],
    },
  ]);

  const lang = localStorage.getItem("lang");
  let size = 2;
  if(lang == "en"){
    size = 3;
  }
  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[size]
  );

  const [activeNews, setActiveNews] = useState(
    useLocation().pathname.split("/")[size+1]
  );


  const [currentTab, setCurrentTab] = useState(tabName[0]);
  const [isActive, setIsActive] = useState(false);
  const [activeFilterOne, setActiveFilterOne] = useState(false);
  const [activeFilterTwo, setActiveFilterTwo] = useState(false);
  const [isMobileActive, setIsMobileActive] = useState(true);
  const [banner, setBanner] = useState([]);
  const [leftTabs, setLeftTabs] = useState();
  const [leftNavId, setLeftNavId] = useState([]);
  const [currentLeftTab, setCurrentLeftTab] = useState([]);
  const [datas, setData] = useState([]);

  let settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 5,
    initialSlide: 0,
    arrows: true,
    nextArrow: <NavArrow direction="right" />,
    prevArrow: <NavArrow direction="left" />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  React.useEffect(() => {
    Api.get("/home/getmenu?slug=" + Paths[size-1]).then((res) => {
      setTabName(res.data.items);
      setBanner(res.data.banner);
      console.log(res.data);
      let activeMenu = res.data.items[res.data.items.findIndex((x) => x.Link == activePath)];
      if(lang ==  "en"){
        activeMenu = res.data.items[res.data.items.findIndex((x) => x.Link_EN == activePath)];
      }
      
      setCurrentTab(activeMenu);
      setLeftTabs(activeMenu.submenu);
    });

    if(activeNews){
     setCurrentLeftTab("destek-news");
    }

  }, [activePath]);

  const allOnClickHandler = () => {
    setActiveFilterOne(true);
    setActiveFilterTwo(true);
  };

  const secSubClick = () => {
    setActiveFilterTwo(!activeFilterTwo);
    setActiveFilterOne(false);
  };

  const renderTitle = () => {
    if (currentTab) {
      if(lang == "en"){
        return <h3>{currentTab.Name_EN}</h3>;
      }else{
        return <h3>{currentTab.Name}</h3>;
      }
      
    }
  };

  const adClickTwo = (id) => {
   if(id == "destek-news"){
    setCurrentLeftTab("destek-news");
   }else if(id == "turmepa-news"){
    setCurrentLeftTab("turmepa-news");
   }else if(id == "robotik-news"){
    setCurrentLeftTab("robotik-news");
   }else{
    setLeftNavId(id);
    var subtab = leftTabs.find((subTab) => subTab.id === id);
    setCurrentLeftTab(subtab);
    
   }
   setIsMobileActive(true);
  };

  function GetLeftMenu(props) {
    return (
      props.tab.submenu.map((subTab) => {
        return (
          <>
          <li
            className={
              leftNavId === subTab.id ? "active" : null
            }
            onClick={() => adClickTwo(subTab.id)}
            key={subTab.id}
          >
            {lang  == "en" ? (
            <span>{subTab.Name_EN ? subTab.Name_EN : "null"}</span>
            ) : (
              <span>{subTab.Name ? subTab.Name : "null"}</span>
            )}
          </li>
           {/* {subTab.id == 1064 ? 
             <div class="months-dropdown active">
               <ul>
                <li>
                    {lang == "en" ? (
                    <Link className="color-black" to="/en/sustainability/Our-Social-Responsibility-Projects"  onClick={() => adClickTwo("turmepa-news")} >
                    Our Works
                  </Link>
                  ):(<Link className="color-black" to="/surdurulebilirlik/sosyal-sorumluluk-projelerimiz"  onClick={() => adClickTwo("turmepa-news")} >
                  Çalışmalarımız</Link>)}
                  </li>
                </ul>
              </div>
            :null}
            {subTab.id == 1065 ? 
              <div class="months-dropdown active">
                <ul>
                 <li>
                 {lang == "en" ? (<Link className="color-black" to="/en/sustainability/Our-Social-Responsibility-Projects"  onClick={() => adClickTwo("robotik-news")} >
                 Our Works
                   </Link>):(
                     <Link className="color-black" to="/surdurulebilirlik/sosyal-sorumluluk-projelerimiz"  onClick={() => adClickTwo("robotik-news")} >
                     Çalışmalarımız
                   </Link>)}
                   </li>
                 </ul>
               </div>
            :null}
            {subTab.id == 1037 ? 
                <div class="months-dropdown active">
                <ul>
                 <li>
                 {lang == "en" ? (<Link className="color-black" to="/en/sustainability/Our-Social-Responsibility-Projects"  onClick={() => adClickTwo("destek-news")} >
                    Our Works
                   </Link>):(
                   <Link className="color-black" to="/surdurulebilirlik/sosyal-sorumluluk-projelerimiz"  onClick={() => adClickTwo("destek-news")} >
                   Çalışmalarımız
                 </Link>)}
                   </li>
                 </ul>
               </div>
            :null} */}
            </>
        );
      })
    );
  }

  function RenderData(tab) {
    if (tab.content.id) {
      if (currentLeftTab=== "destek-news") {
        return (
          <>
          <div className="sustanibility-container container-sm with-tabs">
            {currentTab.submenu && currentTab.submenu.length > 0 ? (
              <>
                <div className={!isMobileActive ? "mobile-tabs-corporate active": "tab-container"}>
                  
                  <ul>
                    {currentTab.submenu
                      ?   <GetLeftMenu tab={currentTab}/>
                      : null}
                  </ul>
                </div>
              </>
            ) : null}
            <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
             <SocialProject id="2"/>
            </div>
          </div>
        </>
        );
      }

      if (currentLeftTab=== "turmepa-news") {
        return (
          <>
          <div className="sustanibility-container container-sm with-tabs">
            {currentTab.submenu && currentTab.submenu.length > 0 ? (
              <>
                <div className={!isMobileActive ? "mobile-tabs-corporate active": "tab-container"}>
                  <ul>
                    {currentTab.submenu
                      ?  <GetLeftMenu tab={currentTab}/>
                      : null}
                  </ul>
                </div>
              </>
            ) : null}
            <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
             <SocialProject id="3"/>
            </div>
          </div>
        </>
        );
      }
      if (currentLeftTab=== "robotik-news") {
        return (
          <>
          <div className="sustanibility-container container-sm with-tabs">
            {currentTab.submenu && currentTab.submenu.length > 0 ? (
              <>
                <div className={!isMobileActive ? "mobile-tabs-corporate active": "tab-container"}>
                  <ul>
                    {currentTab.submenu
                      ?  <GetLeftMenu tab={currentTab}/>
                      : null}
                  </ul>
                </div>
              </>
            ) : null}
            <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
             <SocialProject id="4"/>
            </div>
          </div>
        </>
        );
      }
      if (tab.content.Name === "Sürdürülebilirlik Raporu") {
        return (
          <>
            <div className="sustanibility-container container-sm">
              <div className="report-container">
                <SustainReport />
              </div>
            </div>
          </>
        );
      }
      if (tab.content.Link === "surdurulebilirlik-raporlari"){
        return (
          <div className="career-container container-sm">
            <SustainabilityReports />
          </div>
        );
      }
      return (
        <>
          <div className="sustanibility-container container-sm with-tabs">
            {currentTab.submenu && currentTab.submenu.length > 0 ? (
              <>
                <div className={!isMobileActive ? "mobile-tabs-corporate active": "tab-container"}>
                  <ul>
                    {currentTab.submenu
                      ?  <GetLeftMenu tab={currentTab}/>
                      : null}
                  </ul>
                </div>
              </>
            ) : null}
            <div style={{ paddingLeft: "5px" ,width:"100%"}}>
              {currentLeftTab && currentLeftTab.content != null ? (

                lang == "en" ? (
                <>
                  <h3>{currentLeftTab.Name_EN}</h3>
                  <div
                  className="sustain-content"
                    dangerouslySetInnerHTML={{
                      __html: currentLeftTab.content.Content_EN,
                    }}
                  ></div>

                  {currentLeftTab.id == 1064 ? 
                    (
                      <>
                      <div className="sustain-content corporate-content-container full-width" style={{marginTop: "20px"}}>
                        <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
                        <SocialProjectList id="3"/>
                        </div>
                      </div>
                      </>
                    ) : null
                  }

                  {currentLeftTab.id == 1065 ? 
                    (
                      <>
                      <div className="sustain-content corporate-content-container full-width" style={{marginTop: "20px"}}>
                        <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
                        <SocialProjectList id="4"/>
                        </div>
                      </div>
                      </>
                    ) :null
                  }

                  {currentLeftTab.id == 1037 ? 
                    (
                      <>
                      <div className="sustain-content corporate-content-container full-width" style={{marginTop: "20px"}}>
                        <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
                        <SocialProjectList id="2"/>
                        </div>
                      </div>
                      </>
                    ) : null
                  }
                </>
                ):( <>
                  <h3>{currentLeftTab.Name}</h3>
                  <div
                  className="sustain-content"
                    dangerouslySetInnerHTML={{
                      __html: currentLeftTab.content.Content_TR,
                    }}
                  ></div>

                  {currentLeftTab.id == 1064 ? 
                    (
                      <>
                      <div className="sustain-content corporate-content-container full-width" style={{marginTop: "20px"}}>
                        <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
                        <SocialProjectList id="3"/>
                        </div>
                      </div>
                      </>
                    ) : null
                  }

                  {currentLeftTab.id == 1065 ? 
                    (
                      <>
                      <div className="sustain-content corporate-content-container full-width" style={{marginTop: "20px"}}>
                        <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
                        <SocialProjectList id="4"/>
                        </div>
                      </div>
                      </>
                    ) :null
                  }

                  {currentLeftTab.id == 1037 ? 
                    (
                      <>
                      <div className="sustain-content corporate-content-container full-width" style={{marginTop: "20px"}}>
                        <div style={!isMobileActive ? { paddingLeft: "5px" ,width:"50%"}: { paddingLeft: "5px" }}>
                        <SocialProjectList id="2"/>
                        </div>
                      </div>
                      </>
                    ) : null
                  }
                </>)
              ) : (
                <>
                  {renderTitle()}
                  {tab.content.content ? (
                    lang == "en" ? (
                    <>
                      <div
                      className="sustain-content"
                        dangerouslySetInnerHTML={{
                          __html: tab.content.content.Content_EN,
                        }}
                      ></div>
                    </>
                    ):(
                      <>
                      <div
                      className="sustain-content"
                        dangerouslySetInnerHTML={{
                          __html: tab.content.content.Content_TR,
                        }}
                      ></div>
                    </>
                    )
                  ) : null}
                </>
              )}              
            </div>
          </div>
        </>
      );
    } else {
      return "";
    }
  }


  

  const adClick = (id) => {
    const tab = tabName.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsMobileActive(true);
    setCurrentLeftTab([]);
    setLeftNavId();
    Api.get("/home/getleftmenu?slug=" + tab.Link).then((res) => {
      if (res.data.items.length > 0) {
        const activeMenu =res.data.items
        setLeftTabs(activeMenu);
      }
    });
  };

  return (
    <>
      <header
        className="sustainability-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="slider-deneme with-padding container-sm">
        <Slider className="slider-tab" {...settings}>
          {tabName
            ? tabName.map((tab) => {
                return (
                  lang == "en" ? (
                  <Link
                    className={currentTab.id === tab.id ? "tab active" : "tab"}
                    key={tab.id}
                    onClick={() => adClick(tab.id)}
                    to={"/en/" + Paths[size-1] + "/" + tab.Link_EN}
                  >
                    {tab.Name_EN}
                  </Link>
                  ):(<Link
                    className={currentTab.id === tab.id ? "tab active" : "tab"}
                    key={tab.id}
                    onClick={() => adClick(tab.id)}
                    to={"/" + Paths[size-1] + "/" + tab.Link}
                  >
                    {tab.Name}
                  </Link>)
                );
              })
            : null}
        </Slider>
      </div>
      <div
        className={"mobile-santral-tabs active"
        }
      >
        {tabName
          ? tabName.map((tab) => {
              return (
                lang == "en" ? (
                <li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  to={"/en/" + Paths[size-1] + "/" + tab.Link_EN}
                  onClick={() => adClick(tab.id)}
                  key={tab.id}
                >
                  <span>{tab.Name_EN}</span>
                </li>
                ):(<li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  to={"/" + Paths[size-1] + "/" + tab.Link}
                  onClick={() => adClick(tab.id)}
                  key={tab.id}
                >
                  <span>{tab.Name}</span>
                </li>)
              );
            })
          : null}
      </div>
      <div className="breadcrumbz container-sm">
        {lang == "en" ? (
        <ol>
          <li>
            <Link to="/en">
              Homepage <span>&gt;</span>
            </Link>
          </li>
          <li>
            <Link to="/sustainability/Our-Policies">
              Sustainability <span>&gt;</span>
            </Link>
          </li>
          <li>
            {tabName.length > 0 || currentTab.id ? (
              <Link to={Paths[size]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        ):(
          <ol>
          <li>
            <Link to="/">
              Anasayfa <span>&gt;</span>
            </Link>
          </li>
          <li>
            <Link to="/surdurulebilirlik/politikalarimiz">
              Sürdürülebilirlik <span>&gt;</span>
            </Link>
          </li>
          <li>
            {tabName.length > 0 || currentTab.id ? (
              <Link to={Paths[size]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
        )}
      </div>
      <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle active"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>
      {
        <Route>
          <RenderData content={currentTab} />
        </Route>
      }
    </>
  );
};

export default Sustainability;
